import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Skeleton from "@mui/material/Skeleton";
import { useAppStore } from "../appStore";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function ScanningList() {
    const baseURL = process.env.REACT_APP_API_URL;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const questions = useAppStore((state) => state.questions);
    const updateQuestions = useAppStore((state) => state.updateQuestions);
    const patient = useAppStore((state) => state.patient);
    const token = useAppStore((state) => state.token);
    const navigate = useNavigate();
    const utype = useAppStore((state) => state.utype);
    const useremail = useAppStore((state) => state.useremail);
    const updateChakra = useAppStore((state) => state.updateChakra);
    const updateMajor = useAppStore((state) => state.updateMajor);
    const updateMinor = useAppStore((state) => state.updateMinor);
    const updateOrgan = useAppStore((state) => state.updateOrgan);

    useEffect(() => {
        if (!token) {
            navigate("/");
        }
        if (utype == "Admin") {
            getUsers();
        } else if (utype == "Healer") {
            getHealerQuestions();
        } else if (utype == "Patient") {
            getPatientQuestions();
        }
        getChakra();
    }, []);

    const getChakra = async () => {
        let posturl = baseURL + "getchakra";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                console.log("chakra", res.data.chakra);
                updateChakra(res.data.chakra);
                updateMajor(res.data.major);
                updateMinor(res.data.minor);
                updateOrgan(res.data.organ);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const getPatientQuestions = async () => {
        let posturl = baseURL + "patientscanning?que=" + useremail;
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateQuestions(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const getHealerQuestions = async () => {
        let posturl = baseURL + "healerscanning?que=" + useremail;
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateQuestions(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const getUsers = async () => {
        let posturl = baseURL + "scanning";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateQuestions(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const deleteUser = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.value) {
                deleteApi(id);
            }
        });
    };

    const deleteApi = async (id) => {
        let posturl = baseURL + "scanning/" + id;
        await axios
            .delete(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(function (res) {
                console.log(res.data);
                if (utype == "Admin") {
                    getUsers();
                } else if (utype == "Healer") {
                    getHealerQuestions();
                } else if (utype == "Patient") {
                    getPatientQuestions();
                }
                Swal.fire(
                    "Submitted!",
                    "Your file has been submitted.",
                    "success"
                );
            })
            .catch(function (error) {
                console.log("kcheckpost" + error); //return 429
            });
    };

    const filterData = (v) => {
        if (v) {
            // setRows([v]);
            updateQuestions([v]);
        } else {
            getUsers();
        }
    };

    const editData = (
        id,
        patient_id,
        label,
        type,
        session,
        question,
        answer
    ) => {
        const data = {
            id: id,
            patient_id: patient_id,
            label: label,
            type: type,
            session: session,
            question: question,
            answer: answer,
        };
        navigate("/edit-scanning", {
            state: {
                id: id,
                patient_id: patient_id,
                label: label,
                type: type,
                session: session,
                question: question,
                answer: answer,
            },
        });
    };

    return (
        <>
            <Paper sx={{ width: "98%", overflow: "hidden", padding: "12px" }}>
                <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ padding: "20px" }}
                >
                    Scanning Status
                </Typography>
                <Divider />
                <Box height={10} />
                <Stack direction="row" spacing={2} className="my-2 mb-2">
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={questions}
                        sx={{ width: 300 }}
                        onChange={(e, v) => filterData(v)}
                        getOptionLabel={(questions) => questions.label || ""}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label="Search Status"
                            />
                        )}
                    />
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}
                    ></Typography>
                    {utype !== "Patient" && (
                        <Button
                            variant="contained"
                            endIcon={<AddCircleIcon />}
                            onClick={() => {
                                navigate("/add-scanning");
                            }}
                        >
                            Add
                        </Button>
                    )}
                </Stack>
                <Box height={10} />
                {questions.length > 0 && (
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Session
                                    </TableCell>
                                    {utype !== "Patient" && (
                                        <TableCell
                                            align="left"
                                            style={{ minWidth: "100px" }}
                                        >
                                            Patient
                                        </TableCell>
                                    )}

                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Created At
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        style={{ minWidth: "100px" }}
                                    >
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {questions
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                key={index}
                                                tabIndex={-1}
                                            >
                                                <TableCell align="left">
                                                    {row.session}
                                                </TableCell>
                                                {utype !== "Patient" && (
                                                    <TableCell align="left">
                                                        {patient.map((user) => {
                                                            return (
                                                                <>
                                                                    <span
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        {user.id ==
                                                                            row.patient_id &&
                                                                            user.email}
                                                                    </span>
                                                                </>
                                                            );
                                                        })}
                                                    </TableCell>
                                                )}

                                                <TableCell align="left">
                                                    {moment(
                                                        row.created_at
                                                    ).format("MMMM Do YYYY")}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Stack
                                                        spacing={2}
                                                        direction="row"
                                                    >
                                                        <EditIcon
                                                            style={{
                                                                fontSize:
                                                                    "20px",
                                                                color: "blue",
                                                                cursor: "pointer",
                                                            }}
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                editData(
                                                                    row.id,
                                                                    row.patient_id,
                                                                    row.label,
                                                                    row.type,
                                                                    row.session,
                                                                    row.question,
                                                                    row.answer
                                                                );
                                                            }}
                                                        />
                                                        {utype !==
                                                            "Patient" && (
                                                            <DeleteIcon
                                                                style={{
                                                                    fontSize:
                                                                        "20px",
                                                                    color: "darkred",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => {
                                                                    deleteUser(
                                                                        row.id
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={questions.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            {questions.length == 0 && (
                <>
                    <Paper
                        sx={{
                            width: "98%",
                            overflow: "hidden",
                            padding: "12px",
                        }}
                    >
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={30}
                        />
                        <Box height={40} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                        <Skeleton
                            variant="rectangular"
                            width={"100%"}
                            height={60}
                        />
                        <Box height={20} />
                    </Paper>
                </>
            )}
        </>
    );
}
